import { render } from "./PhotosSpread.vue?vue&type=template&id=a542477e"
import script from "./PhotosSpread.vue?vue&type=script&lang=js"
export * from "./PhotosSpread.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/cbundgaard-bitbucket/artivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__